// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-checkbox .custom-control-label[data-v-44df1529]::before {\n    border-radius: .50rem!important;cursor: pointer;\n}\n.no-image-gallery i.far[data-v-44df1529] {\n  font-size: 42px;\n  color: #959595;\n}\n.custom-z-index[data-v-44df1529] {\n  z-index: 0 !important; /* Set the desired z-index */\n}\n", ""]);
// Exports
module.exports = exports;
